var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app__page -options"},[_c('div',{staticClass:"options-panel"},[_c('h3',[_vm._v("Preparing for first run")]),_vm._v(" "),_c('p',[_vm._v("Database type: "+_vm._s(_vm.type))]),_vm._v(" "),_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar__bar",style:({width: _vm.progress})})]),_vm._v(" "),_c('ul',_vm._l((_vm.item),function(i){return _c('li',{key:i},[_vm._v(_vm._s(i))])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28a02546","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-precache.vue
// module id = 287
// module chunks = 0